import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Polygon, PolygonProps } from 'react-leaflet';
import { ISegmentationPolygonProps } from '../SegmentationLayerFeatures';

interface ITempRectangleProps {
  isActive: boolean;
  tooltip?: ReactElement;
}

export const RectangleFeature = observer((props: ISegmentationPolygonProps & PolygonProps & ITempRectangleProps): ReactElement => {
  const handleRef = (element: Polygon<ISegmentationPolygonProps & PolygonProps>): void => {
    if (props.isActive && element && 'enableEdit' in element.leafletElement && typeof element.leafletElement.enableEdit === 'function') {
      element.leafletElement.enableEdit();
    }
  };

  const { tooltip, ...rest } = props;

  return (
    <Polygon<ISegmentationPolygonProps & PolygonProps>
      {...rest}
      ref={handleRef}
    >
      {tooltip}
    </Polygon>
  );
});
